export const MOBILE_CONSUMER_PROMOTION_SET_EMAIL_FLOW_ID =
  'mobile-consumer-promotion-set-email';

export enum MobileConsumerPromotionSetEmailScreenNames {
  COLLECT_EMAIL = 'Collect Email',
  VERIFY_OTP = 'Verify OTP',
}

export const MOBILE_CONSUMER_PROMOTION_SET_EMAIL_SCREEN_IDS = {
  COLLECT_EMAIL: 'SC37DdHTZiJUNsYrC4XMzAr6GRw2V',
  VERIFY_OTP: 'SC37DdHDdYx6JvKc3kQ26uFQMGv8C',
};

export const MOBILE_CONSUMER_PROMOTION_SET_EMAIL_INTERACTION_IDS = {
  CANCEL_COLLECT_EMAIL: '5Wgl023sDr',
  SUBMIT_EMAIL: 'q4FeBI9x5i',
  CANCEL_VERIFY_OTP: 'ImL01ZU0vi',
  SUBMIT_CODE: 'oneTimeCodeId',
  USE_DIFFERENT_EMAIL: 'pnOqEGpL1b',
  RESEND: 'resend',
};
